/**
 * Очистка клиентского состояния сессии (logout / смена пользователя).
 *
 * React Query кэш живёт в памяти вкладки и не привязан к пользователю
 * (ключи вида ['sync', 'student_v2']). Без очистки следующий вошедший в той же
 * вкладке учитель видел ученики/оценки предыдущего (ПДн), а курсор
 * инкрементального pull заставлял его тянуть только «изменения» поверх чужих
 * данных. Вынесено из AuthContext, чтобы покрываться node-тестами.
 */
import { currentTeacherIdStorage } from '../api/client.ts'
import { resetSince } from '../api/entitySyncState.ts'

/** Минимальный контракт QueryClient, нужный для очистки. */
export interface ClearableQueryCache {
  clear(): void
}

export function clearClientSession(cache: ClearableQueryCache): void {
  currentTeacherIdStorage.set(null)
  resetSince()
  cache.clear()
}
